<template>
  <div>
    <div>
      <div>
        <div class="flex status">
          <span class="h4">{{$t('profile.status')}}</span>
          <span :class="statusCircle(merchantProfile.status)"></span>
        </div>
        <div class="flex status">
          <span class="h4 mr8">{{$t('profile.account_type')}}:</span>
          <span class="h3">{{merchantProfile.billing ? merchantProfile.billing.plan : '-'}}</span>
        </div>
        <h3>{{$t('profile.company_profile')}}</h3>
        <material-input
          :label="$t('profile.name')"
          name="name"
          v-model="merchantProfile.name"
          placeholder="Name"
          class="material-input"
          color="grey"
          :size="20"
          :validation="validation.required"
        />
        <p class="field-label">{{$t('profile.description')}}</p>
        <textarea v-model="merchantProfile.description" rows="10" class="material-input"></textarea>
        <p class="field-label">{{$t('profile.category')}}</p>
        <multiselect
          class="material-input"
          label="label"
          track-by="value"
          v-model="merchantProfile.category"
          :options="categories"
          :searchable="false"
          :allow-empty="false"
        ></multiselect>
        <div class="field material-input field-autocomplete" placeholder="Indirizzo">
          <vue-google-autocomplete
            id="address"
            name="address"
            ref="address"
            class="input"
            placeholder
            :value="merchantProfile.address"
            types="address"
            :country="['it']"
            v-on:placechanged="getAddressData"
          ></vue-google-autocomplete>
          <label for="address">{{$t('profile.location')}}</label>
          <div class="baseline"></div>
          <span class="info" :class="{error: addressError}">{{$t('errors.address_required')}}</span>
        </div>
        <h3>{{$t('profile.company_info')}}</h3>
        <material-input
          name="companyName"
          :label="$t('profile.company_name')"
          v-model="merchantProfile.companyName"
          placeholder="company name"
          class="material-input col-lg-5"
          color="grey"
          :size="20"
          :validation="validation.required"
        />
        <material-input
          name="companyEmail"
          :label="$t('profile.company_email')"
          v-model="merchantProfile.companyEmail"
          placeholder="company email"
          class="material-input col-lg-5 col-lg-offset-2"
          color="grey"
          :size="20"
          :validation="validation.email"
        />
        <material-input
          name="tel"
          :label="$t('profile.tel')"
          v-model="merchantProfile.tel"
          :placeholder="$t('profile.tel')"
          class="material-input col-lg-5"
          color="grey"
          :size="20"
          :validation="validation.tel"
        />
        <material-input
          name="vat"
          :label="$t('profile.vat')"
          v-model="merchantProfile.vat"
          :placeholder="$t('profile.vat')"
          class="material-input col-lg-5 col-lg-offset-2"
          color="grey"
          :size="20"
          :validation="validation.vat"
          readonly
        />
        <p class="field-label">{{$t('profile.ref_npo')}}</p>
        <p class="material-input">{{ merchantProfile.refNpo ? merchantProfile.refNpo.name : '-'}}</p>
        <donapp-button
          :disabled="$validator.errors.items.length > 0 || loading || !merchantProfile.category"
          :text="$t('profile.save')"
          :action="saveMerchant"
          class="gradient-merchant"
        ></donapp-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MaterialInput from '@/components/shared/inputs/Material'
import DonappButton from '@/components/shared/buttons/Button'
import SelectDropDown from '@/components/shared/inputs/SelectDropDown'
import circleStatusClass from '@/mixins/StatusCircle'
import Multiselect from 'vue-multiselect'
import apiService from '@/services/ApiService'
import DonappDialog from '@/components/shared/Dialog'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'merchant-profile',
  mixins: [circleStatusClass],
  components: {
    MaterialInput,
    DonappButton,
    DonappDialog,
    SelectDropDown,
    Multiselect,
    VueGoogleAutocomplete
  },
  $_veeValidate: {
    validator: 'new' // give me a new validator each time.
  },
  data() {
    return {
      selectedCategory: '',
      categories: [
        { value: 'restaurant-bar', label: this.$t('merchant_categories.restaurant-bar') },
        { value: 'grocery', label: this.$t('merchant_categories.grocery') },
        { value: 'beauty-wellness', label: this.$t('merchant_categories.beauty-wellness') },
        { value: 'sport', label: this.$t('merchant_categories.sport') },
        { value: 'clothing', label: this.$t('merchant_categories.clothing') },
        { value: 'furniture', label: this.$t('merchant_categories.furniture') },
        { value: 'jewellery', label: this.$t('merchant_categories.jewellery') },
        { value: 'other', label: this.$t('merchant_categories.other') }
      ],
      merchantProfile: {},
      error: undefined,
      loading: false,
      disabled: true,
      validation: {
        required: 'required|min:5',
        email: 'required|email',
        tel: 'numeric|min:6',
        vat: 'required|min:11|max:16'
      },
      addressError: false,
      filterKey: '',
      fileSize: 102400
    }
  },
  mounted: async function() {
    try {
      this.error = undefined
      this.loading = true
      const { data: result } = await apiService.getProfile('merchants', this.merchant._id)
      if (result.success) {
        this.merchantProfile = result.data
        this.merchantProfile.category = this.categories.find(category => category.value === result.data.category)
      } else {
        this.error = result.error.message
        this.$toasted.error(this.error)
      }
    } catch (error) {
      this.error = error.message || this.$i18n.t('errors.something_wrong')
      this.$toasted.error(this.error)
    }
    this.loading = false
  },
  methods: {
    getAddressData: function(result, place, id) {
      if (result && result.longitude && result.latitude && result.route) {
        this.addressError = false
        this.merchantProfile.loc = [result.longitude, result.latitude]
        this.merchantProfile.address = result.route
      } else this.addressError = true
    },
    async saveMerchant() {
      this.loading = true
      try {
        const { data: result } = await apiService.updateProfile('merchants', this.merchant._id, {
          ...this.merchantProfile,
          category: this.merchantProfile.category.value
        })
        if (result.success) {
          this.merchantProfile = result.data
          this.$refs.address.update(this.merchantProfile.address)
          this.merchantProfile.category = this.categories.find(category => category.value === result.data.category)
          this.$toasted.success(this.$i18n.t('messages.profile_updated'))
        } else {
          this.$toasted.error(this.$i18n.t('errors.something_wrong') + ': ' + result.error.message)
        }
      } catch (error) {
        this.$toasted.error(this.$i18n.t('errors.something_wrong') + ': ' + error)
      }
      this.loading = false
    }
  },
  computed: {
    ...mapState({
      merchant: state => state.user.loggedRole.merchant
    }),
    merchantImg: function() {
      return this.merchant.img && this.merchant.img.length > 2 ? this.merchant.img : './static/img/shop.svg'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/config.scss';

.all-slider {
  max-width: 600px;
}

.material-input {
  margin-bottom: 17px;
}

.flex.status {
  align-items: center;
}

h3,
.h3 {
  @include biggestFontSize();
  font-weight: 700;
  line-height: 21px;
  cursor: default;
}

h3 {
  margin: 34px 0 17px;
}

.flex.status .h3 {
  margin-top: 0px;
  margin-bottom: 0px;
}

textarea {
  width: 100%;
  border-color: $dividerGrey;
}

.cover-image {
  border-radius: 8px 8px 0px 0px;
  width: 600px;
  height: 300px;
  background-size: cover;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;

  i {
    color: white;
  }
}

.overlay {
  width: 100%;
  height: 100%;
  position: relative;
  margin-top: -50px;
  margin-right: 0px;
  margin-bottom: 17px;
  margin-left: 0px;
  border-radius: 8px;
  background-color: $grey;
  opacity: 0;
}

.field-label {
  color: #aab7c4;
  cursor: default;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 400;
}

.field-label.empty {
  font-size: 14px;
}

.cover-image.clickable:hover {
  .middle {
    opacity: 1;
    z-index: 1;
    height: 50px;
  }

  .middle .material-icons {
    font-size: 50px;
  }

  .overlay {
    opacity: 0.6;
  }
}

.field-autocomplete {
  position: relative;
  width: 100%;
  height: 50px;
}

.field-autocomplete.half-width {
  width: 50%;
}

.field-autocomplete.quarter-width {
  width: calc(25% - 10px);
}

.baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 4px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  pointer-events: none;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}

.input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 6px;
  color: #32325d;
  background-color: transparent;
}

.input::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.input:focus,
.input:not(.empty) {
  opacity: 1;
}

.input:focus::-webkit-input-placeholder,
.input:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.input:focus::-moz-placeholder,
.input:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.input:focus:-ms-input-placeholder,
.input:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.input:focus ~ label,
.input:not(.empty) ~ label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-21px);
  cursor: default;
}

.input:focus ~ label {
  color: #24b47e;
}

.input.invalid ~ label {
  color: #ffa27b;
}

.input:focus ~ label ~ .baseline {
  background-color: #24b47e;
}

.input:focus.invalid ~ label ~ .baseline {
  background-color: #e25950;
}

input {
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.StripeElement--webkit-autofill {
  background: transparent !important;
}

input {
  -webkit-animation: 1ms void-animation-out;
}

.info {
  position: absolute;
  bottom: -17px;
  font-size: 10px;
  white-space: nowrap;
  display: none;

  &.error {
    color: red;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/account/Profile.vue